/**
 * @fileoverview Polyfill for globalThis
 * @author 唯然<weiran.zsd@outlook.com>
 */
var g = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : {};

g.globalThis = g;
